import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4800Model } from '../kymw4800.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

import type { BuyerCrossGoodsList } from '../vo/buyer-cross-goods-list.model';

// リクエスト構造
interface GetBuyerCrossGoodsSetListRequest {
  search: {
    GetBuyerCrossGoodsSetList: {
      parameter: {
        MediumType: string;
      },
      combination: {
        parameter: {
          BuyerCode: string;
        }
      }[];
    };
  };
}

/**
 * クロス商品設定一覧取得サービス
 * @export GetBuyerCrossGoodsSetListService
 * @class GetBuyerCrossGoodsSetListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetBuyerCrossGoodsSetListService extends PlessJsonResponderSub<any> {
  private model: KYMW4800Model;
  private successFunc: Function;
  private exceptionErrorFunc: Function;
  private vo: BuyerCrossGoodsList;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBuyerCrossGoodsSetListService
   */
  private getBody(): PlessRequest {
    const combinations = [] as { parameter: { BuyerCode: string } }[];
    for (const buyerCode of this.vo.buyerCodeList) {
      combinations.push({
        parameter: { BuyerCode: buyerCode }
      });
    }

    const request: GetBuyerCrossGoodsSetListRequest = {
      search: {
        GetBuyerCrossGoodsSetList: {
          parameter: {
            MediumType: this.vo.mediumType,
          },
          combination: combinations,
        }
      }
    };

    return new PlessRequest(request);
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4800Model} model モデルクラス
   * @param {any} vo 
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetBuyerCrossGoodsSetListService
   */
  execute(model: KYMW4800Model, vo: any, successFunc: Function, exceptionErrorFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.exceptionErrorFunc = exceptionErrorFunc;
    this.send('getBuyerCrossGoodsSetList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetBuyerCrossGoodsSetListService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setBuyerCrossGoodsData(data);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetBuyerCrossGoodsSetListService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
